import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Login from "./components/Login";
import Dashboard from "./components/Dashboard";
import AddPackageForm from "./components/AddPackageForm";
import EditPackage from "./components/EditPackage";
import CallbackRequests from "./components/CallbackRequests";
import PackageRequest from "./components/PackageRequest";
import './index.css'; // or './styles/globals.css' if you renamed it


function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />

        {/* Dashboard Layout */}
        <Route path="/dashboard/*" element={<Dashboard />}>
          <Route path="packageenquiry" element={<PackageRequest />} />
          <Route path="addpackage" element={<AddPackageForm />} />
          <Route path="editpackage" element={<EditPackage />} />
          <Route path="callbackrequests" element={<CallbackRequests />} />
          {/* Add more nested routes here */}
        </Route>

        {/* Redirect everything else to login */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
